import { Column } from 'primereact/column'
import { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import EditAdtrAuthorization from '../adtrAuthorizationUpdate/editAdtrAuthorization';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

const NewAdtrAuthorizations = forwardRef((props, ref) => {
  const {cdiacNumber, onDataFetch, reportId, updateType} = props;
  const [isLoading, setIsLoading] = useState(true);
  const [newAdtrAuthorizations, setNewAdtrAuthorizations] = useState([]); //New adtr authorizations in Review table
  const [editAdtrAuths, setEditAdtrAuths] = useState(false);
  const [selectedAdtrAuthInfo, setSelectedAdtrAuthInfo] = useState([]);
  const [fiscalYrEndDate, setFiscalYrEndDate] = useState("");
  let tableType = "Review";


  const viewEditFormatter = (row) => {
      return (
        <div style={{
          textAlign: "center",
          lineHeight: "normal"
        }}>
          <FontAwesomeIcon icon={faPencilAlt} className="custom-icon" onClick={(e)=>onRowClick(e, row)}/> 
        </div>
      );
    }


    const onRowClick = (e, row) => {
      // e.preventDefault();
      setSelectedAdtrAuthInfo(row);
      setFiscalYrEndDate(row.fiscalYrEndDate);
      setEditAdtrAuths(true);
    }


  const handleModalClose = () => {
    setEditAdtrAuths(false);
    getNewAuthorizationsByRFSId(reportId);
  }


  useEffect(() => {
    if (reportId){
      getNewAuthorizationsByRFSId(reportId);
    }
   
  }, [reportId]);


  const getNewAuthorizationsByRFSId = (selectedFinalSaleId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getNewAdtrAuthorizationsByFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "finalSaleId": selectedFinalSaleId,
        "updateType": updateType,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setNewAdtrAuthorizations(result.data.responses[key]);
          onDataFetch(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  useImperativeHandle(ref, () => {
      return {
        getNewAuthorizationsByRFSId
      };
  }, [])


  const  columnsNewAdtrAuthorizations = [{
    dataField: 'fiscalYrEndDate',
    text: 'Fiscal Year End Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.fiscalYrEndDate),
  },{
    dataField: 'authorizationName',
    text: 'Authorization Name',
    sort: true,
  }, {
    dataField: 'authorizationDate',
    text: 'Authorization Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.authorizationDate),
  }, {
    dataField: 'beginAmt',
    text: 'Begin Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.beginAmt),
  }, {
    dataField: 'duringAmt',
    text: 'During Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.duringAmt),
  }, {
    dataField: 'authorityReducedAmt',
    text: 'Authority Reduced Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReducedAmt),
  }, {
    dataField: 'authorityReplenishAmt',
    text: 'Authority Replenish Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReplenishAmt),
  }, {
    dataField: 'lapsedAmt',
    text: 'Lapsed Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.lapsedAmt),
  }, {
    dataField: "",
    text: "Action",
    formatter: viewEditFormatter,
  }
  ];


  return (
    <div>
      <div>
        <DataGrid
          title="New ADTR Authorizations:"
          dataSource={newAdtrAuthorizations}
          sortField='fiscalYrEndDate'
          sortOrder={1}
          showQuickSearch={false}
          emptyDataMessage='No data available to display'
        >
          {columnsNewAdtrAuthorizations.map((column, i) => {
            return (
              <Column
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort}
                body={column.formatter}
                hidden={column.hidden}
              />)
          })
          }
        </DataGrid>
      </div>
      <div>
        {editAdtrAuths && <EditAdtrAuthorization onModalClose={handleModalClose} adtrAuthInfo={selectedAdtrAuthInfo} fiscalYrEndDate={fiscalYrEndDate} cdiacNumber={cdiacNumber} tableType={tableType} />}
      </div>
    </div>

  )
});

export default NewAdtrAuthorizations;

